import React, { useState } from "react"
import FormLabel from "components/FormLabel"
import { useFormContext } from "react-hook-form"
import { FormHelperText } from "components/FormHelperText"
import Box from "@material-ui/core/Box"
import { IFormElementProps } from "./types"
import { FormController } from "./FormController"

export function FormElement(props: React.PropsWithChildren<IFormElementProps>) {
  const { label, name, disabled, extraHelperText, onChange, inputRender, spacing, className, required } = props

  const [isFocused, setIsFocused] = useState<boolean>(false)
  const context = useFormContext()
  const handleFocus = () => setIsFocused(true)
  const handleBlur = () => setIsFocused(false)
  const baseRenderProps = {
    onFocus: handleFocus,
    onBlur: handleBlur,
  }

  const handleChange = (event: any, checked?: any) => {
    if (!onChange) return
    // Some custom inputs, like React Select, return the value instead of an event.
    const value = typeof event === "string" ? event : (event.target.value as string)
    onChange(value, checked)
  }

  if (!context) {
    return (
      <Box className={className} {...spacing}>
        {/* Note: Standalone inputs have no error functionality at the moment */}
        <FormLabel name={name} label={label} disabled={disabled} isFocused={isFocused} required={required} />
        {inputRender({ ...baseRenderProps, onChange: handleChange })}
        <FormHelperText extraHelperText={extraHelperText} label={label} disabled={disabled} />
      </Box>
    )
  }

  return (
    <Box className={className} {...spacing}>
      <FormController
        {...props}
        {...baseRenderProps}
        onChange={handleChange}
        inputRender={inputRender}
        isFocused={isFocused}
      />
    </Box>
  )
}
